import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.scss';
import { useForm } from 'react-hook-form';
import cx from 'classnames';
import Alert from '../utils/Alert';
import { AxiosPost } from '../http/Axios';

const Login = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    document.title = 'LeapFrog Lab Registration Admin Portal';
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleLogin = async (formData) => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    const params = new URLSearchParams();
    params.append('username', formData.username);
    params.append('password', formData.password);

    try {
      await AxiosPost(
        process.env.REACT_APP_ADMIN_SERVICE + '/login',
        params,
        'application/x-www-form-urlencoded'
      );
      // If AxiosPost succeeds, navigate to search page
      navigate('/search-page', { state: { email: formData.username } });
    } catch (err) {
      console.error('Error logging in', err);
      setError('Login failed. Please check your credentials and try again.');
      setIsSubmitting(false);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="login-page page-container">
      <div className="page-title">
        <h1>LeapFrog Lab Registration Administration</h1>
      </div>
      {error && <Alert message={error} />}
      <div className="login-form form-group">
        <form onSubmit={handleSubmit(handleLogin)}>
          <div
            className={cx('field-group', {
              'validation-errors': errors.username,
            })}
          >
            <label htmlFor="username">
              <span>*</span>Email Address
            </label>
            <input
              type="text"
              placeholder="Format: user@leapfrog.com"
              {...register('username', {
                required: true,
                maxLength: 99,
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: 'Please enter a valid email address (e.g. user@leapfrog.com)',
                },
              })}
            />
            {errors.username && (
              <span className="error-label">
                {errors.username.message || 'Please enter your LeapFrog email (e.g. user@leapfrog.com)'}
              </span>
            )}
          </div>

          <div
            className={cx('field-group', {
              'validation-errors': errors.password,
            })}
          >
            <label htmlFor="password">
              <span>*</span>Password
            </label>
            <input
              type="password"
              {...register('password', {
                required: true,
              })}
            />
            {errors.password && (
              <span className="error-label">
                Please enter your LeapFrog password
              </span>
            )}
          </div>

          <div className="field-group button">
            <button
              className="button primary"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
